import watchChangeSelectedLanguageSaga from '@/store/sagas/user/changeSelectedLanguageSaga';

import watchChangePasswordSaga from './changePasswordSaga';
import watchForgotPasswordSaga from './forgotPasswordSaga';
import watchResetPasswordSaga from './resetPasswordSaga';

const userSagas = [watchChangePasswordSaga(), watchForgotPasswordSaga(), watchResetPasswordSaga(), watchChangeSelectedLanguageSaga()];
export default userSagas;
